import styles from "./Settings.module.css";

interface Props {
  setIsDeleteModalOpen: (isDeleteModalOpen: boolean) => void;
  isDeleting: boolean;
  deletionProgress: any;
  setDeletionProgress: (progress: any) => void;
  handleDeleteAllData: () => void;
  embedded: boolean;
}

export default function DeleteDataModal({
  setIsDeleteModalOpen,
  isDeleting,
  deletionProgress,
  setDeletionProgress,
  handleDeleteAllData,
  embedded = false,
}: Props) {
  const inner = (
    <div className={styles.modalContent}>
      <h2 className={styles.modalTitle}>Delete All My Data</h2>

      <p className={styles.modalDescription}>
        This will permanently delete all your moods, causes, and personal cause
        types. This action cannot be undone.
      </p>

      {/* Progress indicator */}
      {isDeleting && deletionProgress.total > 0 && (
        <div className={styles.progressIndicator}>
          <div className={styles.progressHeader}>
            <span className={styles.progressStage}>
              {deletionProgress.stage}
            </span>
            <span className={styles.progressCount}>
              {deletionProgress.current}/{deletionProgress.total}
            </span>
          </div>
          <div className={styles.progressBarContainer}>
            <div
              className={styles.progressBarFill}
              style={{
                width: `${(deletionProgress.current / deletionProgress.total) * 100}%`,
              }}
            />
          </div>
        </div>
      )}

      <div className={styles.modalButtonContainer}>
        <button
          onClick={() => {
            handleDeleteAllData();
            localStorage.clear();
          }}
          disabled={isDeleting}
          className="proceed-button"
        >
          {isDeleting ? "Deleting..." : "Delete All Data!"}
        </button>
        <button
          onClick={() => {
            setIsDeleteModalOpen(false);
            setDeletionProgress({ current: 0, total: 0, stage: "" });
          }}
          className="proceed-button"
        >
          Cancel
        </button>
      </div>
    </div>
  );

  if (embedded) {
    return inner;
  }

  return <div className={styles.modalOverlay}>{inner}</div>;
}
